import { useSearchParams } from 'react-router-dom';

export const useQueryParam = (
  queryParam: 'cartid' | 'draftid' | 'payments_return',
): string | null => {
  const [searchParams] = useSearchParams();
  return searchParams.get(queryParam);
};
